import React, { useState } from "react";

// import JS files
import MuiModal from "./MuiModal";
import MuiButton from "./MuiButton";
import useFetch from "../../context/useFetch";
import { toast } from "react-toastify";

const RemoveModalTemplate = (props) => {
  let windowWidth = window.screen.width;

  return (
    <>
      <MuiModal
        openModal={props.openModal}
        setOpenModal={props.setOpenModal}
        width="w-2/5"
      >
        <div>
          <div>
            <span className="text-sm">{props.text}</span>
          </div>
          <div className="flex justify-end mt-4">
            <div className="mr-2">
              <MuiButton
                onClick={() => props.accept()}
                variant="outlined"
                //     icon={<AddIcon />}
                color="error"
                text="بلی"
              />
            </div>
            <div className="mr-2">
              <MuiButton
                onClick={() => props.setOpenModal(false)}
                variant="outlined"
                //     icon={<AddIcon />}
                color="success"
                text="خیر"
              />
            </div>
          </div>
        </div>
      </MuiModal>
    </>
  );
};

export default RemoveModalTemplate;
